import { Helmet } from "react-helmet-async";

const SITE_URL = "https://jobvinum.io";
const DEFAULT_IMAGE = "/og-image.png";

/** Sets per-page title/meta description/canonical/Open Graph tags. Falls back to the static
 * defaults already present in public/index.html when a page doesn't need anything custom. */
export default function SEO({ title, description, path = "", image = DEFAULT_IMAGE }) {
  const url = `${SITE_URL}${path}`;
  const absoluteImage = image.startsWith("http") ? image : `${SITE_URL}${image}`;
  return (
    <Helmet>
      {title && <title>{title}</title>}
      {description && <meta name="description" content={description} />}
      <link rel="canonical" href={url} />
      {title && <meta property="og:title" content={title} />}
      {description && <meta property="og:description" content={description} />}
      <meta property="og:url" content={url} />
      <meta property="og:image" content={absoluteImage} />
      {title && <meta name="twitter:title" content={title} />}
      {description && <meta name="twitter:description" content={description} />}
      <meta name="twitter:image" content={absoluteImage} />
    </Helmet>
  );
}
